import { render, staticRenderFns } from "./AdminMonitoring.vue?vue&type=template&id=454e5e45&"
import script from "./AdminMonitoring.vue?vue&type=script&lang=js&"
export * from "./AdminMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./AdminMonitoring.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports